/* <cr-slider> — mockup script.js:40-66 (setupSlider). Shared by New Arrivals and (later) Testimonials.
   Markup: [data-cr-slider-track], [data-cr-slider-prev], [data-cr-slider-next], [data-cr-slider-bar] > span */
if (!customElements.get('cr-slider')) {
  customElements.define('cr-slider', class extends HTMLElement {
    connectedCallback() {
      this.t = this.querySelector('[data-cr-slider-track]');
      this.prev = this.querySelector('[data-cr-slider-prev]');
      this.next = this.querySelector('[data-cr-slider-next]');
      this.bar = this.querySelector('[data-cr-slider-bar] span');
      if (!this.t) return;
      this.update = this.update.bind(this);

      if (this.prev) this.prev.addEventListener('click', () => this.t.scrollBy({ left: -this.step(), behavior: 'smooth' }));
      if (this.next) this.next.addEventListener('click', () => this.t.scrollBy({ left: this.step(), behavior: 'smooth' }));
      this.t.addEventListener('scroll', this.update, { passive: true });
      this.t.addEventListener('keydown', (e) => {
        if (e.target !== this.t) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); if (this.next) this.next.click(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); if (this.prev) this.prev.click(); }
      });

      // Mouse drag to scroll (js:60-64); a drag suppresses the click that follows it.
      let down = false, startX = 0, startLeft = 0, moved = false;
      this.t.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; startX = e.clientX; startLeft = this.t.scrollLeft;
        this.t.style.scrollSnapType = 'none'; this.t.style.scrollBehavior = 'auto';
      });
      this.onMove = (e) => { if (!down) return; const dx = e.clientX - startX; if (Math.abs(dx) > 4) moved = true; this.t.scrollLeft = startLeft - dx; };
      this.onUp = () => { if (!down) return; down = false; this.t.style.scrollSnapType = ''; this.t.style.scrollBehavior = ''; };
      window.addEventListener('pointermove', this.onMove);
      window.addEventListener('pointerup', this.onUp);
      this.t.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

      window.addEventListener('resize', this.update);
      this.update();

      if (window.Shopify && window.Shopify.designMode) {
        // Theme Editor: scroll the selected block's card into view.
        this.onBlockSelect = (e) => { if (this.t.contains(e.target)) e.target.scrollIntoView({ block: 'nearest', inline: 'start' }); };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('pointermove', this.onMove);
      window.removeEventListener('pointerup', this.onUp);
      window.removeEventListener('resize', this.update);
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    // js:44-48 — scroll by the number of whole cards that fit
    step() {
      const item = this.t.children[0];
      if (!item) return this.t.clientWidth;
      const gap = parseFloat(getComputedStyle(this.t).columnGap) || 0;
      const w = item.getBoundingClientRect().width + gap;
      return w * Math.max(1, Math.floor((this.t.clientWidth + gap) / w));
    }

    // js:49-55
    update() {
      const t = this.t;
      const max = t.scrollWidth - t.clientWidth;
      if (this.prev) this.prev.disabled = t.scrollLeft <= 2;
      if (this.next) this.next.disabled = t.scrollLeft >= max - 2;
      if (!this.bar) return;
      const ratio = t.clientWidth / t.scrollWidth;
      this.bar.style.width = (ratio * 100) + '%';
      this.bar.style.left = (max > 0 ? (t.scrollLeft / max) * (1 - ratio) * 100 : 0) + '%';
    }
  });
}
